import { SEND_PING } from '../actions/types';

export default function (state = null, action) {
  switch (action.type) {
    case SEND_PING:
      return action.payload;
    default:
      return state;
  }
}